import React, { useEffect, useState } from "react";
import { PageTitle, Panel, Table } from "../components/ui";
import { useI18n } from "../i18n";
import { CL } from "../api";

export default function EmissionFactors() {
  const { t } = useI18n();
  const [rows, setRows] = useState([]);
  useEffect(() => { CL.listFactors().then(setRows).catch(() => {}); }, []);

  return (
    <div data-testid="factors-page">
      <PageTitle title={t("factors")} subtitle="ISO 14064 / GHG Protocol" />
      <Panel>
        <Table head={[{ label: t("name") }, { label: t("scope") }, { label: t("category") }, { label: t("unit") }, { label: "kg CO₂e / birim", right: true }, { label: "Kaynak" }]}>
          {rows.map((r) => (
            <tr key={r.id} className="hover:bg-[#fafbf6]" data-testid={`factor-row-${r.id}`}>
              <td className="px-4 py-3 font-medium text-[#1b2420]">{r.name}</td>
              <td className="px-4 py-3 text-[#4b544c]">Kapsam {r.scope}</td>
              <td className="px-4 py-3 text-[#4b544c]">{r.category}</td>
              <td className="px-4 py-3 text-[#4b544c]">{r.unit}</td>
              <td className="px-4 py-3 text-right font-medium text-[#14512f]">{r.factor}</td>
              <td className="px-4 py-3 text-[#8a8f83]">{r.source}</td>
            </tr>
          ))}
        </Table>
      </Panel>
    </div>
  );
}
